
























































import Vue from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import syncFetch from 'sync-fetch'

interface DailyJson {
  Date: string;
  PreviousDate: string;
  PreviousURL: string;
  Timestamp: string;
  Valute: Record<string, Currency>;
}

interface Currency {
  CharCode: string;
  ID: string;
  Name: string;
  Nominal: number;
  NumCode: string;
  Previous: number;
  Value: number;
}

interface TableCurrency extends Currency {
  Delta: string;
}

interface Settings {
  currenciesUrl: string;
}

const settings: Settings = syncFetch('/settings.json', {
  headers: {
    Accept: 'application/json'
  }
}).json()

export default Vue.extend({
  name: 'Currencies',

  data: () => ({
    loading: false,
    error: false,
    search: '',
    dailyJson: {} as DailyJson,
    currencies: [] as TableCurrency[],
    headers: [
      {
        text: 'Цифр. код',
        value: 'NumCode',
        sortable: true,
        align: 'start'
      },
      {
        text: 'Букв. код',
        value: 'CharCode',
        sortable: true
      },
      {
        text: 'Единиц',
        value: 'Nominal',
        sortable: true
      },
      {
        text: 'Валюта',
        value: 'Name',
        sortable: true
      },
      {
        text: 'Курс',
        value: 'Value',
        sortable: true
      },
      {
        text: 'Динамика',
        value: 'Delta',
        sortable: true
      }
    ]
  }),

  computed: {
    dailyJsonDate (): string {
      if (!this.dailyJson.Date) {
        // new Date().toLocaleDateString('ru-RU')
        return '—'
      }
      return new Date(this.dailyJson.Date).toLocaleString('ru-RU')
    }
  },

  mounted () {
    this.getDailyJson()
  },

  methods: {
    getDailyJson (): void {
      this.loading = true
      this.error = false
      // fetch('https://www.cbr-xml-daily.ru/daily_json.js')
      fetch(settings.currenciesUrl)
        .then((response) => {
          return response.json()
        })
        .then((data: DailyJson) => {
          // console.log(data)
          this.dailyJson = data
          Object.entries(data.Valute).forEach(([code, currency]) => {
            const tableCurrency = currency as TableCurrency
            let delta = (currency.Value - currency.Previous).toFixed(4)
            if (parseFloat(delta) > 0) {
              delta = '+' + delta
            }
            tableCurrency.Delta = delta
            this.currencies.push(tableCurrency)
          })
          this.loading = false
        })
        .catch((error) => {
          console.error(error)
          this.loading = false
          this.error = true
        })
    },
    getColor (delta: string) {
      if (delta[0] === '+') return 'green'
      else if (delta[0] === '-') return 'red'
    },
    getArrow (delta: string) {
      if (delta[0] === '+') return '▲'
      else if (delta[0] === '-') return '▼'
    }
  }
})
